webpackJsonp([107818501498521],{

/***/ 162:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _get = __webpack_require__(15);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _typography = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlogPostTemplate = function (_React$Component) {
	  _inherits(BlogPostTemplate, _React$Component);
	
	  function BlogPostTemplate() {
	    _classCallCheck(this, BlogPostTemplate);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  BlogPostTemplate.prototype.render = function render() {
	    var _props$data$markdownR = this.props.data.markdownRemark,
	        html = _props$data$markdownR.html,
	        _props$data$markdownR2 = _props$data$markdownR.frontmatter,
	        path = _props$data$markdownR2.path,
	        title = _props$data$markdownR2.title,
	        subTitle = _props$data$markdownR2.subTitle,
	        date = _props$data$markdownR2.date,
	        tags = _props$data$markdownR2.tags,
	        src = _props$data$markdownR2.featuredImage.childImageSharp.sizes.src;
	
	    var siteTitle = (0, _get2.default)(this.props, 'data.site.siteMetadata.title');
	
	    return _react2.default.createElement(
	      'div',
	      {
	        style: {
	          maxWidth: (0, _typography.rhythm)(32),
	          padding: (0, _typography.rhythm)(1.5) + ' ' + (0, _typography.rhythm)(3 / 4),
	          margin: '0 auto'
	        }
	      },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          title + ' | ' + siteTitle
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: subTitle + ' | ' + tags.join(', ') }),
	        _react2.default.createElement('meta', { 'http-equiv': 'content-language', content: 'en-gb' }),
	        _react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
	        _react2.default.createElement('meta', { property: 'og:url', content: 'https://www.movementkitchen.co.uk/blog' + path }),
	        _react2.default.createElement('meta', { property: 'og:title', content: title + ' | ' + siteTitle }),
	        _react2.default.createElement('meta', { property: 'og:description', content: subTitle + ' | ' + tags.join(', ') }),
	        _react2.default.createElement('meta', { property: 'og:image', content: 'https://www.movementkitchen.co.uk' + src }),
	        _react2.default.createElement('meta', { property: 'twitter:card', content: 'summary_large_image' }),
	        _react2.default.createElement('meta', { property: 'twitter:url', content: 'https://www.movementkitchen.co.uk/blog' + path }),
	        _react2.default.createElement('meta', { property: 'twitter:title', content: title + ' | ' + siteTitle }),
	        _react2.default.createElement('meta', { property: 'twitter:description', content: subTitle + ' | ' + tags.join(', ') }),
	        _react2.default.createElement('meta', { property: 'twitter:image', content: 'https://www.movementkitchen.co.uk' + src })
	      ),
	      _react2.default.createElement(
	        'h1',
	        { style: _extends({}, (0, _typography.scale)(0.5), { textAlign: 'center' }) },
	        title
	      ),
	      date && _react2.default.createElement(
	        'p',
	        {
	          style: _extends({}, (0, _typography.scale)(-1 / 5), {
	            display: 'block',
	            textAlign: 'center',
	            marginBottom: (0, _typography.rhythm)(2),
	            marginTop: (0, _typography.rhythm)(-0.5)
	          })
	        },
	        date
	      ),
	      subTitle && _react2.default.createElement(
	        'p',
	        { style: { textAlign: 'center' } },
	        subTitle
	      ),
	      _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: html } })
	    );
	  };
	
	  return BlogPostTemplate;
	}(_react2.default.Component);
	
	exports.default = BlogPostTemplate;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-blog-post-js-c767a3f2f7a778e4313c.js